import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'

async function start() {
  const { default: App } = await import('./App')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
